<template>
  <div class="c-player-popup c-player-popup--dark c-player-popup--countdown">
    <div class="c-player-popup__container">
      <div class="c-player-popup__container--row">
        <span
          class="o-icon"
          :class="icon"
        ></span>
        <span>
          {{ countdown.days }}
          {{ countdown.hours }}
          {{ countdown.minutes }}
          {{ countdown.seconds }}
        </span>
      </div>
      <span
        v-if="isProgrammeDisabled"
        class="c-player-popup__message"
      >
        {{ $t('player.programmeUnavailable.message') }}
      </span>
    </div>
  </div>
</template>
<script>
  import epgTime from '@/shared/libs/time';
  import { addLeadingZero } from '@/shared/utils/time';

  const SECOND = 1000;
  const MINUTE = SECOND * 60;
  const HOUR = MINUTE * 60;
  const DAY = HOUR * 24;

  export default {
    props: {
      availableSince: {
        type: Number,
        required: true,
      },
      isProgrammeDisabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        time: epgTime,
      };
    },
    computed: {
      timeLeft() {
        return Math.max(this.availableSince - this.time.now.valueOf(), 0);
      },
      countdown() {
        if (!this.timeLeft) {
          return null;
        }

        const minutesLeft = Math.floor(this.timeLeft / MINUTE);
        const hoursLeft = Math.floor(this.timeLeft / HOUR);
        const daysLeft = Math.floor(this.timeLeft / DAY);

        return {
          seconds: addLeadingZero(Math.floor(this.timeLeft / SECOND) % 60) + 's',
          minutes: minutesLeft ? `${addLeadingZero(minutesLeft % 60)}m : ` : '',
          hours: hoursLeft ? `${addLeadingZero(hoursLeft) % 24}h : ` : '',
          days: daysLeft ? `${daysLeft}d : ` : '',
        };
      },
      icon() {
        return this.isProgrammeDisabled ? 'o-icon--lock' : 'o-icon--time';
      },
    },
    watch: {
      timeLeft(val) {
        if (val <= 0) {
          this.$emit('countdownStop');
        }
      },
    },
    mounted() {
      return this.time.updateWithInterval(SECOND);
    },
    beforeDestroy() {
      this.time.stopUpdate();
    },
  };
</script>
